
export class CountryConstants {

    public static USA_CODE: string = "US";
    public static CANADA_CODE: string = "CA";

    public static USA: any = {
        id: 1,
        code: CountryConstants.USA_CODE,
        name: "United States Of America"
    }

    public static CANADA: any = {
        id: 2,
        code: CountryConstants.CANADA_CODE,
        name: "Canada"
    }
}